import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
`;

export const Row = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;

  .dateRangeWrapper {
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;

    .selectWrapper {
      min-width: 200px;
      flex: 0;
    }

    .datesWrapper {
      width: 350px;
    }
  }
`;

export const Title = styled('h3')`
  font-weight: 700;
  font-size: 18px;
  line-height: 125%;
  color: ${theme.palette.text.dark};
  display: flex;
  align-items: center;

  .filtersButton {
    margin-left: 24px;
    padding: 0 12px 0 4px;

    .label {
      display: inline-flex;
      align-items: center;
      font-weight: 400;
      color: ${theme.palette.text.dark};

      svg {
        width: 24px;
        height: 24px;
        margin-bottom: 3px;
      }
    }
  }
`;

export const ViewType = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;

  svg {
    width: 24px;
    height: 24px;
    color: ${theme.palette.secondary.main};
    cursor: pointer;

    &.current,
    &:hover {
      color: ${theme.palette.text.dark};
    }
  }
`;
